(() => {
  if (window.__sweepsBound) return;
  window.__sweepsBound = true;

  const form = document.getElementById('giveaway-form');
  const submitBtn = document.getElementById('submit-btn');
  const thanks = document.getElementById('sweeps-thanks');
  const honeypot = document.getElementById('website');
  const statusEl = document.getElementById('form-status');

  // ✅ just the URL, nothing else
  const GAS_URL = "https://script.google.com/macros/s/AKfycbzMQBmIhphRNQuaPY8E2BX_qlU9ehA9OiuO2MYYT_d0vWQ4H5243jTb_gasi-uQ1kjuqA/exec";

  if (!form || !submitBtn) return;

  // make sure thanks is hidden at start
  if (thanks) thanks.hidden = true;

  const setStatus = (m) => { if (statusEl) statusEl.textContent = m; };

  // helpers
  const formToParams = () => new URLSearchParams({
    first_name: document.getElementById('first_name').value.trim(),
    last_name:  document.getElementById('last_name').value.trim(),
    email:      document.getElementById('email').value.trim(),
    address:    document.getElementById('address').value.trim(),
    city:       document.getElementById('city').value.trim(),
    state:      document.getElementById('state').value,
    zip:        document.getElementById('zip').value.trim(),
    website:    honeypot?.value || "",
    page_url:   location.href,
    submission_id: (crypto.randomUUID?.() || (Date.now() + "-" + Math.random().toString(36).slice(2)))
  });

  async function fetchWithTimeout(url, opts = {}, ms = 5000) {
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), ms);
    try {
      const res = await fetch(url, { ...opts, signal: ctrl.signal });
      return res;
    } finally {
      clearTimeout(timer);
    }
  }

  function tryBeacon(url, params) {
    try {
      const blob = new Blob([params.toString()], { type: 'application/x-www-form-urlencoded;charset=UTF-8' });
      return navigator.sendBeacon(url, blob);
    } catch {
      return false;
    }
  }

  async function sendSubmission(params) {
    const opts = {
      method: 'POST',
      // If you added CORS headers in Apps Script, change this to 'cors'
      mode: 'no-cors',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
      body: params.toString(),
      keepalive: true
    };

    // first attempt (short)
    try {
      await fetchWithTimeout(GAS_URL, opts, 5000);
      return true;
    } catch (_) {}

    // retry (longer)
    try {
      await fetchWithTimeout(GAS_URL, opts, 8000);
      return true;
    } catch (_) {}

    // last-ditch
    tryBeacon(GAS_URL, params);
    return false;
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (submitBtn.disabled) return;
    if (honeypot && honeypot.value) return; // bot

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    // lock UI and show thanks immediately (optimistic)
    submitBtn.disabled = true;
    submitBtn.setAttribute('aria-busy', 'true');
    setStatus('Submitting…');

    form.hidden = true;
    if (thanks) thanks.hidden = false;
    setStatus('Thanks, your entry was received.');

    const params = formToParams();
    await sendSubmission(params);

    // leave button disabled to avoid duplicates
    submitBtn.removeAttribute('aria-busy');
  });

  // safety: if user navigates away very fast, try to send
  window.addEventListener('pagehide', () => {
    if (!submitBtn?.disabled) return; // only if we were submitting
    tryBeacon(GAS_URL, formToParams());
  });
})();
